import { render, staticRenderFns } from "./QuotesDetailResponseResume.vue?vue&type=template&id=4287a32f&scoped=true&"
import script from "./QuotesDetailResponseResume.vue?vue&type=script&lang=js&"
export * from "./QuotesDetailResponseResume.vue?vue&type=script&lang=js&"
import style0 from "./QuotesDetailResponseResume.vue?vue&type=style&index=0&id=4287a32f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4287a32f",
  null
  
)

export default component.exports